import styled from "styled-components";
import { V3Caption } from "../Typography";

export const ProgressContainer = styled.div`
    height: 15px;
    border-radius: 15px;
    width: 100%;
    background-color: #DDDFE3;
    overflow: hidden;
`;

export const ProgressFiller = styled.div<{ completed: number, speed: number }>`
    height: 100%;
    width: ${({ completed }) => `${completed}%`};
    background-color: #7FA7F6;
    border-radius: 15px;
    text-align: right;
    transition: ${({ speed }) => `width ${speed}s ease-out`};
`;

export const ProgressLabel = styled(V3Caption)`
    padding: 0px 5px;
    color: white;
    font-weight: bold;
`;